import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Facebook, Twitter, Instagram, Music } from 'react-feather';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
      <footer className="text-light py-5 mt-auto navbar-custom">
        <Container>
          <Row>
            <Col md={4} className="mb-4">
              <img
                  src="/logo.png"
                  alt="MyWeeshy Logo"
                  className="me-2"
                  width={50}
                  style={{ objectFit: "cover" }}
              />
              <h5 className="mb-3 d-inline align-middle">
                MyWeeshy
              </h5>
              <p className="text-light">
                {t('footer.tagline') || 'Connect with your audience through music requests and donations.'}
              </p>
            </Col>

            <Col md={4} className="mb-4">
              <h5 className="mb-3 text-light">Quick Links</h5>
              <ul className="list-unstyled">
                <li><a href="#features" className="footer-link">Features</a></li>
                <li><a href="#pricing" className="footer-link">Pricing</a></li>
                <li><a href="#about" className="footer-link">About Us</a></li>
                <li><a href="#contact" className="footer-link">Contact</a></li>
              </ul>
            </Col>



            <Col md={4} className="mb-4">
              <h5 className="mb-3 text-light">Connect With Us</h5>
              <div className="social-links d-flex gap-2">
                <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Facebook"
                >
                  <Facebook size={20} />
                </a>
                <a
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Twitter"
                >
                  <Twitter size={20} />
                </a>
                <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Instagram"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </Col>

          </Row>

          <hr className="my-4 border-secondary" />

          <div className="text-center mt-3">
            <p className="text-light mb-1">
              © {currentYear} MyWeeshy. {t('footer.allRightsReserved') || 'All rights reserved.'}
            </p>
            <p className="text-white small" style={{ fontStyle: 'italic' }}>
              Made with <span className="text-white">❤️</span> for DJs & music lovers <span className="text-white">🎶</span>
            </p>
          </div>



        </Container>
      </footer>
  );
};

export default Footer;
